import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "form-group row" }
const _hoisted_4 = { class: "col-sm-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, "Tipo de documento", -1)
const _hoisted_6 = { class: "col-lg-8" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, "Nro de documento", -1)
const _hoisted_8 = { class: "form-group row" }
const _hoisted_9 = { class: "col-sm-12" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", null, "Nombres completos", -1)
const _hoisted_11 = { class: "form-group row" }
const _hoisted_12 = { class: "col-sm-6" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", null, "Primer apellido", -1)
const _hoisted_14 = { class: "col-sm-6" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", null, "Segundo apellido", -1)
const _hoisted_16 = { class: "form-group row" }
const _hoisted_17 = { class: "col-sm-6" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", null, "Sexo", -1)
const _hoisted_19 = { class: "col-sm-6" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", null, "Fecha de nacimiento", -1)
const _hoisted_21 = { class: "form-group row" }
const _hoisted_22 = { class: "col-sm-12" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", null, "Nacionalidad", -1)
const _hoisted_24 = { class: "form-group row" }
const _hoisted_25 = { class: "col-sm-12" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", null, "Dirección", -1)
const _hoisted_27 = { class: "form-group row" }
const _hoisted_28 = { class: "col-sm-6" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", null, "Teléfono", -1)
const _hoisted_30 = { class: "col-sm-6" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", null, "Celular", -1)
const _hoisted_32 = { class: "form-group row" }
const _hoisted_33 = { class: "col-sm-12" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", null, "Email (1)", -1)
const _hoisted_35 = { class: "form-group row" }
const _hoisted_36 = { class: "col-sm-12" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", null, "Email (2)", -1)
const _hoisted_38 = { class: "footer text-left" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: _ctx.titleDialog,
    modelValue: _ctx.isModalVisible,
    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.isModalVisible) = $event)),
    class: "bg-light rounded w-100 w-md-80 w-lg-50",
    onOpen: _ctx.onOpen,
    onClosed: _ctx.onClosed,
    "close-on-click-modal": false,
    top: "2vh",
    "lock-scroll": "",
    "destroy-on-close": ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_form, {
            ref: "ruleFormRef",
            model: _ctx.form,
            "status-icon": "",
            rules: _ctx.rules,
            class: "form form-label-right"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createVNode(_component_el_form_item, {
                    prop: "doctype",
                    rules: [{required: true, message: 'campo requerido', trigger: ['blur', 'change']}]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.form.doctype,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.doctype) = $event)),
                        placeholder: "Seleccione",
                        class: "selectdoc"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getDocuments, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.id,
                              value: item.id,
                              label: item.name
                            }, null, 8, ["value", "label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createVNode(_component_el_form_item, {
                    prop: "docnumber",
                    rules: [{required: true, message: 'campo requerido', trigger: ['blur', 'change']}]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.docnumber,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.docnumber) = $event)),
                        clearable: true,
                        "show-word-limit": "",
                        maxlength: "15"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createVNode(_component_el_form_item, {
                    prop: "firstname",
                    rules: [{required: true, message: 'campo requerido', trigger: ['blur', 'change']}]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.firstname,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.firstname) = $event)),
                        maxlength: "50"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode(_component_el_form_item, {
                    prop: "lastname",
                    rules: [{required: true, message: 'campo requerido', trigger: ['blur', 'change']}]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.lastname,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.lastname) = $event)),
                        maxlength: "50"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createVNode(_component_el_form_item, {
                    prop: "surname",
                    rules: [{required: true, message: 'campo requerido', trigger: ['blur', 'change']}]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.surname,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.surname) = $event)),
                        maxlength: "50"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createVNode(_component_el_form_item, {
                    prop: "gender",
                    rules: [{required: true, message: 'campo requerido', trigger: ['blur', 'change']}]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.form.gender,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.gender) = $event)),
                        class: "w-100",
                        placeholder: "Selecciona"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getGender, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.id,
                              label: item.name,
                              value: item.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createVNode(_component_el_form_item, {
                    prop: "birthday",
                    rules: [{type: 'date', required: true, message: 'campo requerido', trigger: ['blur', 'change']}]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.form.birthday,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.birthday) = $event)),
                        class: "w-100",
                        type: "date",
                        placeholder: "seleccione",
                        "value-format": "YYYY-MM-DD",
                        format: "DD/MM/YYYY",
                        onBlur: _ctx.handleBlur
                      }, null, 8, ["modelValue", "onBlur"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createVNode(_component_el_form_item, {
                    prop: "idcountry",
                    rules: [{required: true, message: 'campo requerido', trigger: ['blur', 'change']}]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.form.idcountry,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.idcountry) = $event)),
                        filterable: "",
                        clearable: "",
                        placeholder: "Seleccione",
                        class: "w-100"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listCountry, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: `lr-${item.idcountry}`,
                              label: `${item.idcountry} - ${item.name}`,
                              value: item.idcountry
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _createVNode(_component_el_form_item, { prop: "address" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.address,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.address) = $event)),
                        maxlength: "300"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _createVNode(_component_el_form_item, { prop: "phone1" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.phone1,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.phone1) = $event)),
                        maxlength: "9"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _createVNode(_component_el_form_item, { prop: "phone2" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.phone2,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.phone2) = $event)),
                        maxlength: "9"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _hoisted_34,
                  _createVNode(_component_el_form_item, { prop: "email1" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.email1,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.email1) = $event)),
                        maxlength: "100"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _hoisted_37,
                  _createVNode(_component_el_form_item, { prop: "email2" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.email2,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.email2) = $event)),
                        maxlength: "100"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.submitForm(_ctx.ruleFormRef)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Guardar")
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "modelValue", "onOpen", "onClosed"]))
}